

import React from 'react';
import ZNetwork from "./znetwork";
import ZUtil from "./zutil";
import ZProps from "./zprops";
import {APP} from "./App";
import AMC from "./AMC";
import PleaseStandBy from "./PleaseStandBy";
import ZooErrorFoundPage from "./ZooErrorFoundPage";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

export default class AMCUserPurchaseSuccessPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	componentDidMount() {
		let parms = ZUtil.getQueryParms();
		ZNetwork.post("checkout:confirm", { session_id: parms.session_id, plan_id: parms.plan_id, product_id: parms.product_id }, (err, user) => {
			if (err) {
				APP.setError("Invalid session - perhaps it has expired? Please try again later.");
				return this.setState({ error: true });
			}
			// update plan and capacity
			ZProps.set("user", user);
			if (user.uri === user.group) {
				ZProps.set("usergroup", user);
			}
			AMC.getPricingPlans((err, plans) => {
				if (!err && (parms.plan_id || parms.product_id)) {
					let plan = plans.plans[parms.plan_id || parms.product_id];
					if (plan) {
						this.setState({ plan: plan, found: true });
					}
				}
			});
		});
	}
	render() {
		let { error, found, plan } = this.state;
		if (error) {
			return <ZooErrorFoundPage />;
		}
		if (!found) {
			return <PleaseStandBy />;
		}
		return	(
			<div className="AMCUserPurchaseSuccessPage">
				<div className="CENTEREDPART">
					<h1><FontAwesomeIcon icon={faCheck} /></h1>
					<h1>Thank you!</h1>
					<h2>And thanks for all your kickass contributions here at Automatic.ai<br/>
					Your <strong>{plan.nickname}</strong> should be ready to go</h2>
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/AMCUserPurchaseSuccessPage.js